var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "property-alarm-list" },
    [
      _vm._l(_vm.alarms, function(alarm, index) {
        return _c("AlarmListItem", {
          key: index,
          attrs: {
            alarm: alarm,
            "calendar-object-instance": _vm.calendarObjectInstance,
            "is-read-only": _vm.isReadOnly
          },
          on: { removeAlarm: _vm.removeAlarm }
        })
      }),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c("AlarmListNew", {
            attrs: { "is-all-day": _vm.calendarObjectInstance.isAllDay },
            on: { addAlarm: _vm.addAlarm }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isListEmpty ? _c("NoAlarmView") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }